export const ANIMATION_CLASSES = {
  animatedSkeleton: 'animated-skeleton',
  animatedFading: 'animated-fading',
  animatedAppear: 'animated-appear',
}